interface GraphqlRequestContext {
  operationName: string;
  correlationId: string;
}

type GraphqlRequestDiagnostics = GraphqlRequestContext &
  (
    | { category: 'network'; status?: never; statusText?: never }
    | { category: 'http'; status: number; statusText: string }
    | { category: 'invalid_payload'; status: number }
    | { category: 'graphql'; status: number; errorCodes: string[]; errorMessages: string[] }
  );

/** Selected transport diagnostics that can reach one terminal recovery report. */
export class GraphqlRequestError extends Error {
  readonly diagnostics: GraphqlRequestDiagnostics;

  constructor(diagnostics: GraphqlRequestDiagnostics, cause?: Error) {
    const message =
      diagnostics.category === 'network'
        ? 'GraphQL network request failed'
        : diagnostics.category === 'graphql'
        ? 'GraphQL response returned errors'
        : diagnostics.category === 'invalid_payload'
        ? 'Invalid JSON response from GraphQL service.'
        : `GraphQL HTTP request failed (${diagnostics.status})${
            diagnostics.statusText ? `: ${diagnostics.statusText}` : ''
          }`;
    super(message);
    this.name =
      diagnostics.category === 'network'
        ? 'GraphQLNetworkError'
        : diagnostics.category === 'graphql'
        ? 'GraphQLResponseError'
        : diagnostics.category === 'invalid_payload'
        ? 'GraphQLInvalidPayloadError'
        : 'GraphQLHttpError';
    this.diagnostics = diagnostics;
    if (cause) Object.defineProperty(this, 'cause', { value: cause, configurable: true });
  }
}
